const publicAsset = (path) => `${process.env.PUBLIC_URL}${path}`

export const defaultLanguage = "tr"

export const languageOptions = [
  { code: "tr", label: "TR" },
  { code: "en", label: "EN" },
]

const socialIcons = ["fa-brands fa-facebook-f", "fa-brands fa-linkedin", "fa-brands fa-twitter", "fa-brands fa-instagram"]

const featuredBase = [
  { cover: publicAsset("/images/hero/h1.png"), nameTr: "Aile Evi", nameEn: "Family House", totalTr: "122 İlan", totalEn: "122 Properties" },
  { cover: publicAsset("/images/hero/h2.png"), nameTr: "Ev ve Villa", nameEn: "House & Villa", totalTr: "155 İlan", totalEn: "155 Properties" },
  { cover: publicAsset("/images/hero/h3.png"), nameTr: "Daire", nameEn: "Apartment", totalTr: "300 İlan", totalEn: "300 Properties" },
  { cover: publicAsset("/images/hero/h4.png"), nameTr: "Ofis ve Stüdyo", nameEn: "Office & Studio", totalTr: "80 İlan", totalEn: "80 Properties" },
  { cover: publicAsset("/images/hero/h6.png"), nameTr: "Villa ve Rezidans", nameEn: "Villa & Condo", totalTr: "80 İlan", totalEn: "80 Properties" },
]

const recentBase = [
  {
    id: 1,
    cover: publicAsset("/images/list/p-1.png"),
    name: "Red Carpet Real Estate",
    location: "210 Zirak Road, Canada",
    categoryKey: "rent",
    priceTr: "3.700",
    priceEn: "3,700",
    typeTr: "Daire",
    typeEn: "Apartment",
  },
  {
    id: 2,
    cover: publicAsset("/images/list/p-2.png"),
    name: "Fairmount Properties",
    location: "5698 Zirak Road, New York",
    categoryKey: "sale",
    priceTr: "9.750",
    priceEn: "9,750",
    typeTr: "Rezidans",
    typeEn: "Condo",
  },
  {
    id: 3,
    cover: publicAsset("/images/list/p-7.png"),
    name: "The Real Estate Corner",
    location: "5624 Mooker Market, USA",
    categoryKey: "rent",
    priceTr: "5.860",
    priceEn: "5,860",
    typeTr: "Ofis",
    typeEn: "Office",
  },
  {
    id: 4,
    cover: publicAsset("/images/list/p-4.png"),
    name: "Herringbone Realty",
    location: "5621 Liverpool, London",
    categoryKey: "sale",
    priceTr: "7.540",
    priceEn: "7,540",
    typeTr: "Ev ve Villa",
    typeEn: "Home & Villa",
  },
  {
    id: 5,
    cover: publicAsset("/images/list/p-5.png"),
    name: "Brick Lane Realty",
    location: "210 Montreal Road, Canada",
    categoryKey: "rent",
    priceTr: "4.850",
    priceEn: "4,850",
    typeTr: "Ticari",
    typeEn: "Commercial",
  },
  {
    id: 6,
    cover: publicAsset("/images/list/p-6.png"),
    name: "Banyon Tree Realty",
    location: "210 Zirak Road, Canada",
    categoryKey: "sale",
    priceTr: "2.742",
    priceEn: "2,742",
    typeTr: "Daire",
    typeEn: "Apartment",
  },
]

const awardsBase = [
  { iconClass: "fa-solid fa-trophy", num: "32 M", name: "Blue Burmin Award" },
  { iconClass: "fa-solid fa-briefcase", num: "43 M", name: "Mimo X11 Award" },
  { iconClass: "fa-solid fa-lightbulb", num: "51 M", name: "Australian UGC Award" },
  { iconClass: "fa-solid fa-heart", num: "42 M", name: "IITCA Green Award" },
]

const locationBase = [
  { id: 1, name: "New Orleans, Louisiana", villas: "12", apartments: "10", offices: "07", cover: publicAsset("/images/location/city-1.png") },
  { id: 2, name: "Jersey, United States", villas: "12", apartments: "10", offices: "07", cover: publicAsset("/images/location/city-2.png") },
  { id: 3, name: "Liverpool, London", villas: "12", apartments: "10", offices: "07", cover: publicAsset("/images/location/city-3.png") },
  { id: 4, name: "New York, United States", villas: "12", apartments: "10", offices: "07", cover: publicAsset("/images/location/city-4.png") },
  { id: 5, name: "Montreal, Canada", villas: "12", apartments: "10", offices: "07", cover: publicAsset("/images/location/city-5.png") },
  { id: 6, name: "California, USA", villas: "12", apartments: "10", offices: "07", cover: publicAsset("/images/location/city-6.png") },
]

const teamBase = [
  { list: "50", cover: publicAsset("/images/customer/team-1.jpg"), address: "Liverpool, Canada", name: "Sargam S. Singh" },
  { list: "70", cover: publicAsset("/images/customer/team-2.jpg"), address: "Montreal, Canada", name: "Harijeet M. Siller" },
  { list: "80", cover: publicAsset("/images/customer/team-3.jpg"), address: "Denver, USA", name: "Anna K. Young" },
  { list: "51", cover: publicAsset("/images/customer/team-4.jpg"), address: "2272 Briarwood Drive", name: "Michael P. Grimaldo" },
  { list: "42", cover: publicAsset("/images/customer/team-5.jpg"), address: "2272 Briarwood Drive", name: "Michael P. Grimaldo" },
  { list: "38", cover: publicAsset("/images/customer/team-5.jpg"), address: "Montreal, USA", name: "Adam K. Jollio" },
]

const priceBase = [
  {
    planKey: "basic",
    bestTr: "",
    bestEn: "",
    planTr: "Başlangıç",
    planEn: "Basic",
    priceTr: "29",
    priceEn: "29",
    ptextTr: "kullanıcı başına, aylık",
    ptextEn: "per user, per month",
    list: [
      { available: true, textTr: "%99,5 kesintisiz erişim garantisi", textEn: "99.5% Uptime Guarantee" },
      { available: true, textTr: "120 GB CDN bant genişliği", textEn: "120GB CDN Bandwidth" },
      { available: true, textTr: "5 GB bulut depolama", textEn: "5GB Cloud Storage" },
      { available: false, textTr: "Kişisel destek hizmeti", textEn: "Personal Help Support" },
      { available: false, textTr: "Kurumsal SLA", textEn: "Enterprise SLA" },
    ],
  },
  {
    planKey: "standard",
    bestTr: "En İyi Değer",
    bestEn: "Best Value",
    planTr: "Standart",
    planEn: "Standard",
    priceTr: "49",
    priceEn: "49",
    ptextTr: "kullanıcı başına, aylık",
    ptextEn: "per user, per month",
    list: [
      { available: true, textTr: "%99,5 kesintisiz erişim garantisi", textEn: "99.5% Uptime Guarantee" },
      { available: true, textTr: "150 GB CDN bant genişliği", textEn: "150GB CDN Bandwidth" },
      { available: true, textTr: "10 GB bulut depolama", textEn: "10GB Cloud Storage" },
      { available: true, textTr: "Kişisel destek hizmeti", textEn: "Personal Help Support" },
      { available: false, textTr: "Kurumsal SLA", textEn: "Enterprise SLA" },
    ],
  },
  {
    planKey: "platinum",
    bestTr: "",
    bestEn: "",
    planTr: "Platin",
    planEn: "Platinum",
    priceTr: "79",
    priceEn: "79",
    ptextTr: "2 kullanıcı, aylık",
    ptextEn: "2 users, per month",
    list: [
      { available: true, textTr: "%100 kesintisiz erişim garantisi", textEn: "100% Uptime Guarantee" },
      { available: true, textTr: "200 GB CDN bant genişliği", textEn: "200GB CDN Bandwidth" },
      { available: true, textTr: "20 GB bulut depolama", textEn: "20GB Cloud Storage" },
      { available: true, textTr: "Kişisel destek hizmeti", textEn: "Personal Help Support" },
      { available: true, textTr: "Kurumsal SLA", textEn: "Enterprise SLA" },
    ],
  },
]

const footerSectionsBase = {
  tr: [
    { title: "SAYFALAR", text: ["Ana Sayfa", "Hakkımızda", "Hizmetler", "İlanlar", "İletişim", "Blog Yazısı"] },
    { title: "BÖLÜMLER", text: ["Üst Menü", "Öne Çıkanlar", "Konumlar", "Danışmanlar", "Videolar", "Alt Bilgi"] },
    { title: "ŞİRKET", text: ["Hakkımızda", "Blog", "Fiyatlandırma", "İş Ortaklığı", "Giriş", "Güncellemeler"] },
  ],
  en: [
    { title: "LAYOUTS", text: ["Home Page", "About Page", "Services", "Properties", "Contact Page", "Single Blog"] },
    { title: "SECTIONS", text: ["Header", "Features", "Locations", "Agents", "Videos", "Footer"] },
    { title: "COMPANY", text: ["About", "Blog", "Pricing", "Affiliate", "Login", "Changelog"] },
  ],
}

const buildFeaturedItems = (language) =>
  featuredBase.map((item) => ({
    cover: item.cover,
    name: language === "tr" ? item.nameTr : item.nameEn,
    total: language === "tr" ? item.totalTr : item.totalEn,
  }))

const buildRecentItems = (language) => {
  const isTurkish = language === "tr"
  const categoryLabels = isTurkish ? { rent: "Kiralık", sale: "Satılık" } : { rent: "For Rent", sale: "For Sale" }

  return recentBase.map((item) => ({
    id: item.id,
    cover: item.cover,
    name: item.name,
    location: item.location,
    categoryKey: item.categoryKey,
    categoryLabel: categoryLabels[item.categoryKey],
    price: isTurkish ? `₺${item.priceTr}` : `$${item.priceEn}`,
    type: isTurkish ? item.typeTr : item.typeEn,
  }))
}

const buildLocationItems = (language) => {
  const isTurkish = language === "tr"
  const labels = isTurkish ? { villas: "Villa", apartments: "Daire", offices: "Ofis" } : { villas: "Villas", apartments: "Apartments", offices: "Offices" }

  return locationBase.map((item) => ({
    id: item.id,
    cover: item.cover,
    name: item.name,
    villas: `${item.villas} ${labels.villas}`,
    apartments: `${item.apartments} ${labels.apartments}`,
    offices: `${item.offices} ${labels.offices}`,
  }))
}

const buildTeamItems = () =>
  teamBase.map((item) => ({
    ...item,
    iconClasses: socialIcons,
  }))

const buildPriceItems = (language) => {
  const isTurkish = language === "tr"

  return priceBase.map((item) => ({
    planKey: item.planKey,
    best: isTurkish ? item.bestTr : item.bestEn,
    plan: isTurkish ? item.planTr : item.planEn,
    price: isTurkish ? item.priceTr : item.priceEn,
    currency: isTurkish ? "₺" : "$",
    ptext: isTurkish ? item.ptextTr : item.ptextEn,
    list: item.list.map((feature) => ({
      iconClass: feature.available ? "fa-solid fa-check" : "fa-solid fa-xmark",
      change: feature.available ? "positive" : "negative",
      text: isTurkish ? feature.textTr : feature.textEn,
    })),
  }))
}

export const getSiteContent = (language = defaultLanguage) => {
  const isTurkish = language === "tr"

  return {
    meta: {
      title: isTurkish ? "EmlakVitrin | Kiralık ve Satılık İlanlar" : "EmlakVitrin | Properties for Rent & Sale",
      description: isTurkish
        ? "Modern emlak sitesi: kiralık ve satılık ilanları keşfedin, danışmanlarla iletişime geçin ve en doğru yatırımı bulun."
        : "Modern real estate website: explore rental and sale listings, contact agents, and discover the right investment.",
    },
    assets: {
      logo: publicAsset("/images/logo.png"),
      logoLight: publicAsset("/images/logo-light.png"),
      aboutIllustration: publicAsset("/immio.jpg"),
    },
    nav: [
      { text: isTurkish ? "Ana Sayfa" : "Home", path: "/" },
      { text: isTurkish ? "Hakkımızda" : "About", path: "/about" },
      { text: isTurkish ? "Hizmetler" : "Services", path: "/services" },
      { text: isTurkish ? "Blog" : "Blog", path: "/blog" },
      { text: isTurkish ? "Fiyatlar" : "Pricing", path: "/pricing" },
      { text: isTurkish ? "İletişim" : "Contact", path: "/contact" },
    ],
    header: {
      logoAlt: isTurkish ? "EmlakVitrin logosu" : "EmlakVitrin logo",
      savedCount: "2",
      savedLabel: isTurkish ? "Listem" : "My List",
      signIn: isTurkish ? "Giriş Yap" : "Sign In",
      languageLabel: isTurkish ? "Dil" : "Language",
      mobileMenuLabel: isTurkish ? "Menüyü aç veya kapat" : "Toggle menu",
    },
    home: {
      hero: {
        title: isTurkish ? "Bir Sonraki Evinizi Keşfedin" : "Search Your Next Home",
        subtitle: isTurkish
          ? "Bulunduğunuz şehirdeki yeni ve öne çıkan ilanları hızlıca keşfedin."
          : "Find new and featured properties located in your local city.",
        cityLabel: isTurkish ? "Şehir / Sokak" : "City / Street",
        cityPlaceholder: isTurkish ? "Konum girin" : "Enter location",
        propertyTypeLabel: isTurkish ? "Mülk Türü" : "Property Type",
        propertyTypePlaceholder: isTurkish ? "Mülk türü" : "Property type",
        priceRangeLabel: isTurkish ? "Fiyat Aralığı" : "Price Range",
        priceRangePlaceholder: isTurkish ? "Fiyat aralığı" : "Price range",
        advanceFilter: isTurkish ? "Gelişmiş Filtre" : "Advanced Filter",
        searchButton: isTurkish ? "İlan ara" : "Search listings",
      },
      featured: {
        title: isTurkish ? "Öne Çıkan Mülk Türleri" : "Featured Property Types",
        subtitle: isTurkish ? "Size uygun tüm mülk seçeneklerini keşfedin." : "Find all types of property.",
        items: buildFeaturedItems(language),
      },
      recent: {
        title: isTurkish ? "Yeni Eklenen İlanlar" : "Recent Property Listed",
        subtitle: isTurkish
          ? "Güncel portföyümüzde yer alan öne çıkan kiralık ve satılık ilanlara göz atın."
          : "Browse the latest rental and sale listings from our featured portfolio.",
        areaUnit: isTurkish ? "/m²" : "/sqft",
        items: buildRecentItems(language),
      },
      awards: {
        title: isTurkish ? "124.000'den fazla mutlu kullanıcıyla güven veren hizmet" : "Over 124,000 happy users still love our services",
        subtitle: isTurkish ? "Ödüllerimiz" : "Our Awards",
        items: awardsBase,
      },
      location: {
        title: isTurkish ? "Konuma Göre Keşfet" : "Explore By Location",
        subtitle: isTurkish
          ? "Popüler bölgelerdeki villa, daire ve ofis seçeneklerini karşılaştırın."
          : "Compare villas, apartments, and office options in popular destinations.",
        items: buildLocationItems(language),
      },
      team: {
        title: isTurkish ? "Öne Çıkan Danışmanlarımız" : "Our Featured Agents",
        subtitle: isTurkish
          ? "Deneyimli danışmanlarımız size en doğru yatırım ve yaşam alanını bulmanızda yardımcı olur."
          : "Our experienced agents help you find the right place to live or invest.",
        listingsLabel: isTurkish ? "İlan" : "Listings",
        messageButton: isTurkish ? "Mesaj Gönder" : "Message",
        callButton: isTurkish ? "Danışmanı ara" : "Call agent",
        verifiedLabel: isTurkish ? "Doğrulanmış danışman" : "Verified agent",
        items: buildTeamItems(),
      },
      pricing: {
        title: isTurkish ? "Paketinizi Seçin" : "Select Your Package",
        subtitle: isTurkish
          ? "İhtiyacınıza uygun destek planını seçin ve profesyonel hizmetlerimizden yararlanın."
          : "Choose the support plan that fits your needs and benefit from our professional services.",
        startPrefix: isTurkish ? "Başlat " : "Start ",
        items: buildPriceItems(language),
      },
    },
    about: {
      backName: isTurkish ? "Hakkımızda" : "About Us",
      backTitle: isTurkish ? "Hakkımızda - Biz Kimiz?" : "About Us - Who We Are?",
      storyTitle: isTurkish ? "Ajans Hikâyemiz" : "Our Agency Story",
      storySubtitle: isTurkish ? "Şirket hikâyemizi ve çalışma sürecimizi keşfedin" : "Check out our company story and work process",
      paragraphs: isTurkish
        ? [
            "EmlakVitrin, kiralık ve satılık gayrimenkul arayışını daha hızlı, şeffaf ve güvenilir hale getirmek için kuruldu. Kullanıcı deneyimini odağa alarak doğru ilanı doğru kişiyle buluşturuyoruz.",
            "Deneyimli danışman ağımız, güncel portföy yönetimimiz ve veri odaklı yaklaşımımız sayesinde hem bireysel alıcılar hem de yatırımcılar için sürdürülebilir çözümler sunuyoruz.",
          ]
        : [
            "EmlakVitrin was founded to make finding rental and sale properties faster, more transparent, and more reliable. We connect the right listing with the right person through a user-focused experience.",
            "With our experienced agent network, up-to-date portfolio management, and data-driven approach, we deliver sustainable solutions for both individual buyers and investors.",
          ],
      button: isTurkish ? "Daha Fazla Bilgi" : "More About Us",
      imageAlt: isTurkish ? "Ofiste çalışan emlak danışmanları" : "Real estate consultants working in an office",
    },
    services: {
      backName: isTurkish ? "Hizmetler" : "Services",
      backTitle: isTurkish ? "Hizmetler - Tüm Hizmetlerimiz" : "Services - All Services",
    },
    blog: {
      backName: isTurkish ? "Blog" : "Blog",
      backTitle: isTurkish ? "Blog - Son İçeriklerimiz" : "Blog Grid - Our Blogs",
    },
    pricingPage: {
      backName: isTurkish ? "30 gün para iade garantisi" : "30 days money back guarantee",
      backTitle: isTurkish ? "Ek ücret yok. Dost canlısı destek" : "No Extra Fees. Friendly Support",
    },
    contact: {
      backName: isTurkish ? "Bize Ulaşın" : "Contact Us",
      backTitle: isTurkish ? "Yardım ve hızlı destek alın" : "Get Help & Friendly Support",
      formTitle: isTurkish ? "Formu Doldurun" : "Fill Up The Form",
      namePlaceholder: isTurkish ? "Ad Soyad" : "Name",
      emailPlaceholder: isTurkish ? "E-posta" : "Email",
      subjectPlaceholder: isTurkish ? "Konu" : "Subject",
      messagePlaceholder: isTurkish ? "Mesajınız" : "Your message",
      submitButton: isTurkish ? "Talep Gönder" : "Submit Request",
    },
    footer: {
      contactTitle: isTurkish ? "Sorularınız mı var?" : "Do You Have Questions?",
      contactSubtitle: isTurkish
        ? "Uzman ekibimiz size en doğru ilanı ve yatırım fırsatını bulmanızda yardımcı olsun."
        : "Let our team help you find the right listing and investment opportunity.",
      contactButton: isTurkish ? "Bugün İletişime Geçin" : "Contact Us Today",
      newsletterTitle: isTurkish ? "Herhangi bir konuda desteğe mi ihtiyacınız var?" : "Do You Need Help With Anything?",
      newsletterText: isTurkish
        ? "Fırsatlar, ipuçları ve güncel ilanlar her ay doğrudan e-posta kutunuza gelsin."
        : "Receive deals, tips, and fresh listings directly in your inbox every month.",
      newsletterPlaceholder: isTurkish ? "E-posta Adresi" : "Email Address",
      newsletterButton: isTurkish ? "Abone Ol" : "Subscribe",
      sections: footerSectionsBase[language] || footerSectionsBase[defaultLanguage],
      legal: isTurkish ? "© 2026 EmlakVitrin. Tüm hakları saklıdır." : "© 2026 EmlakVitrin. All rights reserved.",
    },
  }
}
